module.exports = __webpack_public_path__ + "media/danger_sound.793548a0.mp3";